import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from '../api/navigator.ts';

/**
 * Synchronizes react-router's navigate function with the Axios client interceptor
 * so that API 401/403 responses can redirect the user.
 */
const NavigatorSync: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null;
};
export default NavigatorSync;
